import moment from 'moment';
import { OptionalDate } from 'components/Reports/Observation/DateRangePicker/DateRangePicker';

export type ObservationCountParamsInput = {
  startDate?: OptionalDate | string | null;
  endDate?: OptionalDate | string | null;
  ageLevel?: string | null;
  nodeIds?: number[];
  includeArchivedClassrooms?: boolean;
  includeArchivedNodes?: boolean;
};

export function formatObservationCountDate(
  date?: OptionalDate | string | null
): string | undefined {
  if (!date) {
    return undefined;
  }

  if (typeof date === 'string') {
    return moment.utc(date).format('YYYY-MM-DD');
  }

  return moment(date).format('YYYY-MM-DD');
}

export function buildObservationsCountParams({
  startDate,
  endDate,
  ageLevel,
  nodeIds = [],
  includeArchivedClassrooms,
  includeArchivedNodes
}: ObservationCountParamsInput) {
  return {
    start_date: formatObservationCountDate(startDate),
    end_date: formatObservationCountDate(endDate),
    age_level: ageLevel,
    node_ids: nodeIds,
    include_archived_classrooms: includeArchivedClassrooms ?? true,
    include_archived_nodes: includeArchivedNodes ?? true
  };
}
